import FooterColumnsInterface from '../interfaces/footer-columns.interface';

export const FooterColumns: FooterColumnsInterface = {
    capabilities: {
        title: 'footer.capabilitiesList.title',
        items: [
            { text: 'Compliance & Regulation', route: '/features#compliance-regulation' },
            { text: 'Inspections', route: '/features#inspections' },
            { text: 'Security Assessments', route: '/features#security-assessments' },
            { text: 'Matter Management', route: '/features#matter-management' },
            { text: 'Asset Management', route: '/features#asset-management' },
            { text: 'Risk Management', route: '/features#risk-management' },
        ],
    },
    features: {
        title: 'footer.featuresList.title',
        items: [
            { text: 'Security & Access Control', route: '/features/security-access-control' },
            { text: 'Smartforms & Templates', route: '/features/smartforms-templates' },
            {
                text: 'Compliance & Audit Automation',
                route: '/features/compliance-audit-automation',
            },
            { text: 'Geographic Intelligence', route: '/features/geographic-intelligence' },
            { text: 'Offline Ready', route: '/features/offline-ready' },
            {
                text: 'Integration Without Complexity',
                route: '/features/integration-without-complexity',
            },
            { text: 'Reporting & Insights', route: '/features/reporting-insights' },
            { text: 'Asset Management', route: '/features/asset-management' },
            { text: 'Risk Management', route: '/features/risk-management' },
        ],
    },
    about: {
        title: 'footer.aboutList.title',
        items: [{ text: 'Company', route: '/about' }],
    },
    contactUs: {
        title: 'footer.contactUsList.title',
        phone: 'footer.contactUsList.phone',
        email: 'footer.contactUsList.email',
        copyright: 'footer.contactUsList.copyright',
        privacyPolicy: 'footer.contactUsList.privacyPolicy',
    },
};
